import React from "react";

const WORDS = [
    "Logo Design",
    "Brand Identity",
    "Packaging",
    "Printing",
    "Signage",
    "Social Media",
    "Websites",
    "Brochures",
    "Corporate Stationery",
];

const Row = () => (
    <div className="flex items-center flex-shrink-0">
        {WORDS.map((w) => (
            <span key={w} className="flex items-center flex-shrink-0">
                <span className="font-poppins font-semibold text-transparent text-4xl md:text-6xl tracking-tight whitespace-nowrap px-6 md:px-10 [-webkit-text-stroke:1px_rgba(212,175,55,0.35)]">
                    {w}
                </span>
                <span className="w-2 h-2 rounded-full bg-gold/60 flex-shrink-0" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <section
        data-testid="services-marquee"
        aria-hidden="true"
        className="relative py-10 md:py-14 bg-[#050505] border-y border-white/5 overflow-hidden select-none"
    >
        <div className="flex w-max animate-marquee will-change-transform">
            <Row />
            <Row />
        </div>
    </section>
);

export default Marquee;
